const { Fragment } = wp.element;

const Error = (props) => {
  const { error, reset } = props;
  
  return (<Fragment>
    {/* Error coming from Google Anlytics API */}
    {error && error.message && 
      <div>
        <p>Received an error:</p>
        <pre style={{ whiteSpace: 'inherit' }}>{error.message}</pre>
      </div>
    }
    {/* Error coming from Meow Analytics directly */}
    {error && !error.message && <div><p>{error}</p></div>}
    {/* Button that will reset the error */}
    {error && <div className='button' onClick={reset}>Try again</div>}
  </Fragment>);
};

export default Error;
